export const environment = {
  production: false,
  apiUrl: 'https://hml.projeto.saudeconectada.cists.com.br/backend',
  cindiKind: 'movia'
};
